export const APPROVED_CATEGORIES_LIST_REQUEST =
  "APPROVED_CATEGORIES_LIST_REQUEST";

export const APPROVED_CATEGORIES_LIST_RESPONSE =
  "APPROVED_CATEGORIES_LIST_RESPONSE";

export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST";

export const EDIT_CATEGORY_REQUEST = "EDIT_CATEGORY_REQUEST";

export const GET_CATEGORY_DETAILS_REQUEST =
  "GET_CATEGORY_DETAILS_REQUEST";

export const GET_CATEGORY_DETAILS_RESPONSE =
  "GET_CATEGORY_DETAILS_RESPONSE";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";

export const CATEGORY_SUB_CATEGORIES_LIST_REQUEST =
  "CATEGORY_SUB_CATEGORIES_LIST_REQUEST";

export const CATEGORY_SUB_CATEGORIES_LIST_RESPONSE =
  "CATEGORY_SUB_CATEGORIES_LIST_RESPONSE";

export const REQUESTS_CATEGORIES_LIST_REQUEST =
  "REQUESTS_CATEGORIES_LIST_REQUEST";

export const REQUESTS_CATEGORIES_LIST_RESPONSE =
  "REQUESTS_CATEGORIES_LIST_RESPONSE";

export const GET_CATEGORY_REQUEST_DETAILS_REQUEST =
  "GET_CATEGORY_REQUEST_DETAILS_REQUEST";

export const GET_CATEGORY_REQUEST_DETAILS_RESPONSE =
  "GET_CATEGORY_REQUEST_DETAILS_RESPONSE";

export const REJECT_CATEGORY_REQUEST = "REJECT_CATEGORY_REQUEST";

export const ACCEPT_CATEGORY_REQUEST = "ACCEPT_CATEGORY_REQUEST";
